$(document).on(
  "tqht_mansite_floattop rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
   $(".open-menu1").click(function (e) {
  e.preventDefault();
  $(".menu").toggleClass("active");
});
  }
);
